import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import classnames from "classnames";
import { Dropdown } from "antd";
interface WidgetProps {
  toggleEdit?: () => void;
  isOpen?: boolean;
  title?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  editable?: boolean;
  bordered?: boolean;
  actionsInDropdown?: boolean;
  actionButtons?: Array<{
    onClick?: () => void;
    icon?: string;
    children?: JSX.Element | string;
  }>;
  children?: React.ReactNode;
}

export class Widget extends React.Component<WidgetProps> {
  render() {
    const { editable, isOpen, toggleEdit, title, actionButtons, bordered, style, actionsInDropdown } = this.props;
    let renderActionButtons;
    if (actionButtons) {
      if (actionsInDropdown) {
        renderActionButtons = (
          <Dropdown
            menu={{
              items: actionButtons.map((item, idx) => ({
                key: idx,
                label: (
                  <>
                    {item.icon ? (
                      <FontAwesomeIcon icon={["far", item.icon as IconName]} fixedWidth={true} className="mr-sm" />
                    ) : null}
                    {item.children}
                  </>
                ),
                onClick: item.onClick,
              })),
            }}
          >
            <div className="docs-dropdown-trigger" onClick={(e) => e.stopPropagation()}>
              <FontAwesomeIcon className="email-action-icon" icon={["far", "ellipsis-v"]} fixedWidth={true} />
            </div>
          </Dropdown>
        );
      } else {
        renderActionButtons = actionButtons.map(({ icon, onClick, children }, idx) => (
          <div key={idx} className="g-card--actions-btn" onClick={onClick}>
            {children ? children : <FontAwesomeIcon icon={["far", icon as IconName]} fixedWidth={true} />}
          </div>
        ));
      }
    }

    const clName = classnames("g-card", { bordered });
    const editIcon = isOpen ? "times" : "pen";
    const showCardHeader = title || renderActionButtons || editable;
    return (
      <div className={clName} style={style}>
        {showCardHeader && (
          <div className="g-card--header">
            <h2 className="g-header">{title}</h2>
            <div className="g-card--actions">
              {renderActionButtons}
              {editable && (
                <div className="g-card--actions-btn" onClick={toggleEdit}>
                  <FontAwesomeIcon icon={["far", editIcon]} fixedWidth={true} />
                </div>
              )}
            </div>
          </div>
        )}
        <div className={`${this.props.className || ""}`}>{this.props.children}</div>
      </div>
    );
  }
}
